import { Checkbox } from '@pmi/dsm-react';
import React, { useState } from 'react';
import styles from './filterBy.module.scss';
import { Option } from '../../../../Admin/People/TabsCard/FilterBy';

export interface FilterAgreementStatusSelectionProps {
  statuses?: string[];
  onChange: (selected: string[]) => void;
  list: Option[];
}

export default function FilterAgreementStatusSelection({
  statuses = [],
  onChange,
  list,
}: FilterAgreementStatusSelectionProps) {
  const [selectedStatus, setSelectedStatus] = useState<string[]>(statuses);
  const onStatusSelect = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    const zone = e.target.value;
    let clone = [...selectedStatus];
    if (checked) {
      clone.push(zone);
    } else {
      clone = clone.filter((z) => z !== zone);
    }
    setSelectedStatus(clone);
    onChange(clone);
  };
  const isStatusSelected = (status: string) => selectedStatus.includes(status);
  return (
    <div className="p-3">
      <h4>Agreement Status</h4>
      <ul className={`${styles.filterOptionList} list-unstyled`}>
        {list.map((s, i) => (
          <li
            className={isStatusSelected(s.value) ? 'active' : ''}
            key={`status-${i.toString()}`}
          >
            <Checkbox
              label={s.label}
              value={s.value}
              labelClass={styles.filterOption}
              onChange={onStatusSelect}
              checked={isStatusSelected(s.value)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
